import { createPinia, type Pinia } from "pinia";

export function createV4hPinia(): Pinia {
  const pinia = createPinia();

  return pinia;
}
